import NAME from "./constants";

export const OPEN_AUDIO_PLAYER = NAME + "/OPEN_AUDIO_PLAYER";
export const CLOSE_AUDIO_PLAYER = NAME + "/CLOSE_AUDIO_PLAYER";

export const SET_VOICE_GENRE = NAME + "/SET_VOICE_GENRE";
export const SET_VOICE_GENRE_FULFILLED = NAME + "/SET_VOICE_GENRE_FULFILLED";
export const SET_VOICE_GENRE_REJECTED = NAME + "/SET_VOICE_GENRE_REJECTED";
